import api from "../../../config/axios";
import { logger } from "../../../utils/logger";

interface CategoriaDepartamento {
  nombre: string;
  capacidad: number;
  departamentos: string[];
  precioCorto: number;
  precioLargo: number;
  precios_individuales?: {
    [key: string]: {
      precioCorto: number;
      precioLargo: number;
    };
  };
}

export interface DepartmentInfo {
  nombre: string;
  precio_corto_base: number;
  precio_largo_base: number;
  capacidad: number;
  categoria?: string;
  tipo?: string | null;
  capacidad_label?: string | null;
  zona?: string | null;
  ubicacion?: string | null;
  camas?: string | null;
}

interface DepartmentInfoResponse {
  departamento: DepartmentInfo;
}

export const fetchCategories = async () => {
  try {
    const response = await api.get<CategoriaDepartamento[]>(
      "/departamentos/categorias"
    );
    return response.data;
  } catch (err) {
    logger.error("Error al cargar categorías:", err);
    throw new Error(
      "Error al cargar las categorías. Por favor, intente de nuevo."
    );
  }
};

export const fetchDepartmentInfo = async (
  departamento: string
): Promise<DepartmentInfo> => {
  try {
    const response = await api.get<DepartmentInfoResponse>(
      `/departamentos/${encodeURIComponent(departamento)}`
    );
    return response.data.departamento;
  } catch (error) {
    logger.error("Error fetching department info:", error);
    throw error;
  }
};
